import { useServiceError } from '@/hooks';
import { queryClient } from '@/Root';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { useMutation, useQuery } from 'react-query';
import {
  createPartReplacements,
  deletePartReplacements,
  getPartReplacements,
} from './PartReplacement.service';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

export function usePartReplacement(obj: {
  CompaniesIds?: string;
  partId: number;
}) {
  const query = useQuery(
    ['replacements', obj.partId],
    () => getPartReplacements(obj),
    { enabled: hasPermissions([Authorities.PART_REPLACEMENT_READ]) },
  );

  useServiceError(query.error);

  return query;
}

export function useCreatePartReplacement() {
  const intl = useIntl();

  const mutation = useMutation(
    (obj: { replacementId?: number; partId?: number }) =>
      createPartReplacements(obj),
    {
      onSuccess() {
        notification.success({
          message: intl.formatMessage({
            id: 'parts.partsReplacement.create.notification.success',
          }),
          description: intl.formatMessage({
            id: 'parts.partsReplacement.create.notification.successDescription',
          }),
        });
        queryClient.invalidateQueries(['replacements']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useDeletePartReplacement() {
  const intl = useIntl();

  const mutation = useMutation(
    (obj: { replacementId: number }) => deletePartReplacements(obj),
    {
      onSuccess() {
        notification.success({
          message: intl.formatMessage({
            id: 'parts.partsReplacement.create.notification.success',
          }),
          description: intl.formatMessage({
            id: 'parts.partsReplacement.create.notification.removeDescription',
          }),
        });
        queryClient.invalidateQueries(['replacements']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
